import { render, staticRenderFns } from "./NoteShow.vue?vue&type=template&id=2372307c&"
import script from "./NoteShow.vue?vue&type=script&lang=js&"
export * from "./NoteShow.vue?vue&type=script&lang=js&"
import style0 from "./NoteShow.vue?vue&type=style&index=0&id=2372307c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports